export default "__VITE_ASSET__DkXpYDI0__"